import CryptoJS from "crypto-js";

export function decryptToken(encryptedToken){
    const password =  process.env.REACT_APP_TOKEN_DECRYPT_PASSWORD;
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedToken).toString(CryptoJS.enc.Hex);
    const SECRET_KEY = CryptoJS.enc.Utf8.parse(password.trim());
    const decrypted = CryptoJS.AES.decrypt(encryptedToken,SECRET_KEY,{
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

